import React from 'react';
import { useBrokerDetailsStore } from '../../../../state/brokerDetailsStore';
import { DropDownBox } from '@apply/components';

export const AgreementVersionField: React.FC = () => {
    const iccaTemplateId = useBrokerDetailsStore((s) => s.iccaTemplateId);
    const updateFields = useBrokerDetailsStore((s) => s.updateFields);
    const agreements = useBrokerDetailsStore((s) => s.agreements);

    return (
        <DropDownBox
            id='iccaId'
            value={iccaTemplateId}
            onChange={(v) => updateFields({ iccaTemplateId: v })}
            label='Agreement Version for This Broker'
            required
            dataSource={agreements}
            displayExpr='name'
            valueExpr='key'
            width='100%'
        />
    );
};
